import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../Core/Store";
import { useAppDispatch } from "../../Core/store.hooks";

const initialState: any = {
  isOpen: true,
};

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    toggleMenu: (state, action: PayloadAction<any>) => {
      return action.payload;
    },
  },
});

export const { toggleMenu } = menuSlice.actions;

export const getMenuStatusSelector = (state: any) => state.menu.isOpen;

export default menuSlice.reducer;
